import { Component, OnInit, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-manual-modal",
  templateUrl: "./manual-modal.component.html",
  styleUrls: ["./manual-modal.component.scss"],
})
export class ManualModalComponent implements OnInit {
  @Input() manualType: string; // ประเภทคู่มือ เช่น 'customer', 'taxinvoice', etc.
  @Input() title: string = "คู่มือการใช้งาน"; // หัวข้อของ modal

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }
}
